import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

import type { UserSearchResponseBody } from '@/app-package';

export type SearchParams = {
  name: string;
  orgId?: string;
  excludeInternalOrgs: boolean;
  isCrossOrgSearch?: boolean;
  isLicensed?: boolean;
  size?: number;
  page?: number;
  includeUnverified?: boolean;
};
const getCrossOrgSearch = async (params: SearchParams) => {
  const config: AxiosRequestConfig = {
    url: '/user/search/cross_org',
    method: 'get',
    params,
  };
  const { data } = await axios.request<UserSearchResponseBody>(config);

  return data;
};

export default getCrossOrgSearch;
